module.exports = __webpack_public_path__ + "img/message-square.ce0836a0.svg";